import BreadCrumb from '@react/shared/components/BreadCrumb';
import Footer from '@react/shared/components/Footer';
import HeaderContainer from '@react/shared/components/Header/Header.container';
import Head from 'next/head';
import React from 'react';
import clsxm from 'sly/lib/clsxm';
import { SITEMAP_INDEX_BREADCRUMB_ITEMS } from 'sly/sitemap/constants';
import { Heading, Link } from 'sly/system';

export const SitemapLink = ({ children, className, ...props }) => {
  return (
    <Link
      className={clsxm('mb-2 block md:w-[calc((100%-1.5rem)/2)]', className)}
      {...props}
    >
      {children}
    </Link>
  );
};

export const SitemapLinkWrapper = ({ children, className, ...props }) => {
  return (
    <div
      {...props}
      className={clsxm(
        'mb-4 md:flex md:flex-wrap md:justify-between',
        className
      )}
    >
      {children}
    </div>
  );
};

export const SitemapLayout = ({
  children,
  className,
  breadcrumbItems = SITEMAP_INDEX_BREADCRUMB_ITEMS,
  headTitle = 'Sitemap | Seniorly',
  metaDescription = 'Seniorly sitemap',
  ...props
}) => {
  return (
    <>
      <Head>
        <title>{headTitle}</title>
        <meta name='description' content={metaDescription} />
      </Head>
      <HeaderContainer />
      <section
        {...props}
        className={clsxm(
          'lg:layout mx-m mb-9 md:mx-l md:w-[42.5rem] lg:mx-auto',
          className
        )}
      >
        <BreadCrumb className='my-m bg-white' items={breadcrumbItems} />

        <Heading font='font-t-xl' as='h1' className='mb-6 text-center'>
          Seniorly Sitemap
        </Heading>
        <hr className='mb-6' />
        {children}
      </section>
      <Footer />
    </>
  );
};
